import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (companyId) => {
	const url = EndPoints.COMPANY_DRAFTS.replace(':companyId', companyId);
	return fetch(Methods.GET, url, null, null, true);
};
